import { enqueueSnackbar, useSnackbar } from 'notistack';

type ApiResponse = {
  meta?: {
    requestStatus?: string;
  };
  error?: {
    message?: string;
  };
  payload?: any
};

type Callback = () => void;

let globalEnqueueSnackbar: any = null;

export const useSnackbarRef = (): void => {
  const { enqueueSnackbar: snackbarHook } = useSnackbar();
  globalEnqueueSnackbar = snackbarHook;
};

function apiHelper(
  res: ApiResponse,
  callBack?: Callback,
  enqueueSnackbarOverride?: any
): void {
  if (res?.meta?.requestStatus === "rejected") {
    const errorMessage = (() => {
      try {
        const msg = res.error?.message || res?.payload?.message;
        return msg ? JSON.parse(msg) : null;
      } catch {
        return { message: res.error?.message || res?.payload?.message || "Something went wrong" };
      }
    })();

    const rawError = errorMessage?.message;
    let message = "Something went wrong";

    if (typeof rawError === "string") {
      message = rawError.replace("Error:", "").trim();
    } else if (rawError && typeof rawError === "object") {
      message = (rawError as any).message || JSON.stringify(rawError);
    } else if (rawError) {
      message = String(rawError);
    }

    const snackbar = typeof enqueueSnackbarOverride === 'function'
      ? enqueueSnackbarOverride
      : (globalEnqueueSnackbar || enqueueSnackbar);

    if (typeof snackbar === "function") {
      snackbar(message, { variant: "error" });
    }
    return;
  }

  if (callBack) {
    if (typeof callBack === "function") {
      try {
        callBack();
      } catch (err) {
        console.error("[apiHelper] callBack threw an error:", err);
      }
    } else {
      console.warn("[apiHelper] Provided callBack is not a function:", typeof callBack);
    }
  }
}

export { apiHelper };
export default apiHelper;